export default "__VITE_ASSET__FVRVfTw$__"